/* @flow */
import actionTypes from '../actions/types';
import features from '../config/feature';

const { componentConfig } = features;

export const INITIAL_STATE = {
  withdrawAddress: [],
  userFiatChargeAddress: [],
  fiatWithdrawAddress: [],
  bankInfo: {},
  assetLogExtraDetail: {},
};

export type UserFiatChargeAddress = {
  coin?: string,
  railCode?: string,
  paymentAccountId?: string,
  providerCode?: string,
  platformFeeStrategy?: number,
  fixFeeAmount?: number,
  feeStrategy?: number,
  dynamicFeeRate?: number,
  platformDynamicFeeRate?: number,
  platformDynamicFeeRate?: number,
  withdrawLimitPerDay?: number,
  withdrawLimitPerTime?: number,
  minChargeAmount?: number,
  hasChargeAmount?: number,
  chargeLimitPerDay?: number,
  hasWithdrawAmount?: number,
  withdrawLimitPerDay?: number,
};

export type WithdrawAddress = {
  address: string,
  addressTag?: string,
  asset?: string,
  name: string,
  whiteStatus?: boolean,
};

export const paymentIsValidFilter = (fiatChargeAddress: UserFiatChargeAddress, coin: string) => fiatChargeAddress.coin === coin &&
  (componentConfig.enableOfflineBank ||
    (fiatChargeAddress.paymentAccountId && fiatChargeAddress.paymentAccountId.length > 0));

export const reducer = (state: any, {
  type, data, paymentId,
}: any) => {
  switch (type) {
    case actionTypes.FETCH_WITHDRAW_ADDRESS_SUCCESS:
      return {
        ...state,
        withdrawAddress: data.result,
      };
    case actionTypes.SET_GENERATE_USER_CHARGE_ADDRESS:
      return { ...state, userChargeAddress: { ...state.userChargeAddress, ...data } };
    case actionTypes.FETCH_ASSET_LOG_EXTRA_DETAIL_SUCCESS:
      if (data.rows && data.rows.length !== 0) {
        return {
          ...state,
          assetLogExtraDetail: { ...state.assetLogExtraDetail, [paymentId]: data.rows },
        };
      }
      return state;
    case actionTypes.FETCH_BANK_INFO_SUCCESS:
      return {
        ...state,
        bankInfo: data,
      };
    case actionTypes.FETCH_BANK_INFO_ERROR:
      return {
        ...state,
        bankInfo: {},
      };
    case actionTypes.FETCH_USER_MONEY_LOG_CRYPTO_SUCCESS:
      return {
        ...state,
        userMoneyLogCrypto: data.data,
        userMoneyLogCryptoTotal: data.total,
      };
    case actionTypes.FETCH_USER_MONEY_LOG_CRYPTO_FAILED:
      return {
        ...state,
        userMoneyLogCrypto: [],
        userMoneyLogCryptoTotal: 0,
      };
    default:
      return state;
  }
};
